import { gql } from 'apollo-boost'

const CREATE_SCRAPING_SESSION_TEMPLATE = gql`
  mutation createScrapingSessionTemplate(
    $alias: String
    $description: String
    $tagGroupIds: [ID!]!
  ) {
    createScrapingSessionTemplate(
      alias: $alias
      description: $description
      tagGroupIds: $tagGroupIds
    )
  }
`

export default CREATE_SCRAPING_SESSION_TEMPLATE
